'use client';

import { c as _c } from "react/compiler-runtime";
import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';
export const useHasStayWithNoAlternatives = () => {
  const $ = _c(5);
  const tripId = useTripId();
  let t0;
  if ($[0] !== tripId) {
    t0 = {
      tripId,
      replaceUnavailable: false
    };
    $[0] = tripId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enabled: false
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: liveCheck
  } = api.trip.liveCheck.useQuery(t0, t1);
  let t2;
  if ($[3] !== liveCheck?.liveCheckOutcome.stays) {
    t2 = liveCheck?.liveCheckOutcome.stays.some(_temp) ?? false;
    $[3] = liveCheck?.liveCheckOutcome.stays;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(stay) {
  return stay.availabilityStatus === "UNAVAILABLE" && stay.alternativesStatus === "NONE_AVAILABLE";
}